export var PaymentAttribute;
(function (PaymentAttribute) {
    PaymentAttribute["AccountNumber"] = "Account Number";
    PaymentAttribute["AccountName"] = "Account Name";
    PaymentAttribute["PolicyNumber"] = "Policy Number";
    PaymentAttribute["InvoiceNumber"] = "Invoice Number";
    PaymentAttribute["ItemNumber"] = "Item Number";
    PaymentAttribute["Carrier"] = "Carrier";
    PaymentAttribute["AssignedAgency"] = "Assigned Agency";
    PaymentAttribute["PaymentAmount"] = "Payment Amount";
    PaymentAttribute["Description"] = "Description";
})(PaymentAttribute || (PaymentAttribute = {}));
//# sourceMappingURL=PaymentAttribute.js.map